import styled from 'styled-components';

interface IContainer {
  size: number;
}

export const StyContainer = styled.div<IContainer>`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;

export const StyLabelContent = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
